import { IconHelp, IconAnchor, IconCalculator } from '@tabler/icons';
const icons = { IconHelp, IconAnchor, IconCalculator };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const Other = {
    id: 'other',
    type: 'group',
    children: [
        {
            id: 'help',
            title: 'Help',
            type: 'item',
            url: '/dashboard',
            icon: icons.IconHelp,
            breadcrumbs: false
        }
    ]
};

export default Other;
